import { Modal } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { Paper, Button, ButtonGroup, Grid, makeStyles } from "@material-ui/core";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import LeaderboardDialog from "./leaderboard-dialogs/LeaderboardDialog";
import MyLeaderboardPoints from "./leaderboard-dialogs/MyLeaderboardPoints";
import LeaderboardCriteria from "./leaderboard-dialogs/LeaderboardCriteria";
import { LeaderBoardData } from "../../containers/experience/scene/Database";
import { db } from "../../config/Firebase";

const useStyles = makeStyles({
  root: {
    boxShadow: "none",
  },
  leaderboardHeader: {
    padding: "1rem",
  },
  criteriaBtn: {
    textAlign: "center",
  },
  leaderboardContainer: {
    padding: "2rem",
  },
  tableContainer: {
    background: "#ffffff87",
    boxShadow: "none",
  },
  table: {
    minWidth: 350,
  },
});

function GetData() {
  db.collection('leaderBoardData').orderBy("data.total", "desc").limit(10)
    .get()
    .then(async (doc) => {
      doc.docs.map((data) => {
        const fetchedData = data.data().data;
        LeaderBoardData.set(data.id, { ...fetchedData });
      });
    })
}

function GetTotal() {
  const tempArr = [];
  LeaderBoardData.forEach((values, key) => {
    if (values.userName !== undefined) {
      tempArr.push({userName: values.userName, total: values.total})
    }
  });
  return tempArr;
}


const LeaderBoards = (props) => {
  // const User = 'vwEoKVt1gR5tuFFQMuzb';
  const classes = useStyles();
  const { open, handleClose } = props;
  const [row, setrow] = useState([])
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [dialogContext, setDialogContext] = React.useState(false);

  const handleDialogClose = () => setDialogOpen(false);

  const handleDialogOpen = (context) => {
    setDialogOpen(true);
    setDialogContext(context);
  };

  useEffect(() => {
    const leaderBoardRef = db.collection('leaderBoardData').orderBy("data.total", "desc").limit(10);
    leaderBoardRef.onSnapshot(analyticsData => {
      const leaderBoardData = [];
      analyticsData.forEach(doc => {
        leaderBoardData.push(doc.data().data);
      })
      console.log(leaderBoardData);
      setrow(leaderBoardData);
    });

  }, [])

  return (
    <>
      <Modal
        show={open}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton />
        <Modal.Body
          style={{ background: "rgb(255 255 255 / 50%)", overflowY: "auto" }}
        >
          <Grid container className={classes.leaderboardHeader} >
            <Grid item xs={12} sm={12} md={6} lg={8} xl={8}>
              <h3>Top 20 users</h3>
            </Grid>
            <Grid item xs={6} sm={4} md={3} lg={2} xl={2} className={classes.criteriaBtn}>
              <Button
                variant={"contained"}
                color={"primary"}
                disableElevation
                onClick={() =>
                  handleDialogOpen(<LeaderboardCriteria />)
                }
              >
                Points Criteria
              </Button>
            </Grid>
            <Grid item xs={6} sm={4} md={3} lg={2} xl={2} className={classes.criteriaBtn} >
              <Button
                variant={"contained"}
                color={"primary"}
                disableElevation
                onClick={() => {
                  GetData();
                  setrow(GetTotal());
                }
                }
              >
                Refresh
              </Button>
            </Grid>
          </Grid>

          <div className={classes.leaderboardContainer}>
            <TableContainer
              component={Paper}
              className={classes.tableContainer}
            >
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>User</TableCell>
                    <TableCell align="right">Points Earned</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.map((row) => (
                    <TableRow key={row.userName} key={Math.random()}>
                      <TableCell component="th" scope="row">
                        {row.userName}
                      </TableCell>
                      <TableCell align="right">{row.total}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Modal.Body>
      </Modal>
      <LeaderboardDialog
        open={dialogOpen}
        handleClose={handleDialogClose}
        content={dialogContext}
      />
    </>
  );
};
export default LeaderBoards;
